import React from "react";
import textConfig from "../utils/text";
import toPath from 'element-to-path';

/**
 * @param values
 * @param backgroundColor
 * @param startOffset
 * @param href
 */
function textRender( values: any, backgroundColor: string, startOffset: string, href:string){
	let { dominantBaseline, transform } = values
	let [__html, { textColor, style, letterSpacing }] = textConfig(values, backgroundColor)

	return <>{(!!__html) && <>
		<text {...{fill: textColor, style, letterSpacing, dominantBaseline}}>
			<textPath href={href} textAnchor={"middle"} startOffset={startOffset}>
				<tspan transform={transform} dangerouslySetInnerHTML={{__html}}/>
			</textPath>
		</text>
	</>}</>
}


function arcRender(
	{ cx, cy, rOuter, rInner }: any,
	fontSize: number, space: number, isBottom?: boolean
){
	let radius: number, sweepFlag = 1;
	fontSize = fontSize || 100;

	if(!isBottom) {
		radius = ((rOuter + rInner) - fontSize )/2 + space;
	}else{
		sweepFlag = 0;
		radius = ((rInner + rOuter) + fontSize)/2 - space;
	}

	const startX = cx - radius, endX = cx + radius;
	return `M ${startX} ${cx} A ${radius} ${radius} 0 0 ${sweepFlag} ${endX} ${cy}`;
}

/**
 *
 * @param props
 * @constructor
 */
export default function Circle(props: any) {
	let {text_1, text_2, Svg, svgProps, children, frameBody, backgroundColor} = props;

	// SVG viewport size
	const space = 100, viewBoxSize = 1000;

	const center = viewBoxSize / 2,
		radius = center - space,
		centerX = center, centerY = center;

	const circleProps = {
		cx: center, cy: center
	}

	let arcProps = {
		...circleProps,
		rInner: center,
		rOuter: radius
	}

	const whiteSpace = 30;
	const scaleFactor = (2 * (radius - whiteSpace)) / viewBoxSize;

	// Đường dẫn cho nửa hình tròn
	const arcPath = arcRender(arcProps, text_1?.fontSize, 10);
	const bottomArcPath = arcRender(arcProps, text_2?.fontSize, 10, true);


	return (<>
		{(!(text_1?.text || text_2?.text)) && <Svg
			xmlns="http://www.w3.org/2000/svg" {...svgProps} viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
		>{children}</Svg>}
		{(!!(text_1?.text || text_2?.text)) && <Svg xmlns="http://www.w3.org/2000/svg" {...svgProps} viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}>
			<defs>
				<path id="topTextPath" d={arcPath} {...{ fill: "none"}} />
				<path id="bottomTextPath" d={bottomArcPath} {...{ fill: "none"}} />

				{/*<circle id="topTextPath" {...circleProps} r={center} fill={'none'}/>*/}
				{/*<circle id="bottomTextPath" {...circleProps} r={center} fill={'none'}/>*/}

				<mask id="ringMask">
					<rect x="0" y="0" width={viewBoxSize} height={viewBoxSize} fill="white"/>
					<circle {...circleProps} r={radius} fill="black"/>
				</mask>
			</defs>

			{/* Group containing the ring */}
			<g>
				{/* Inner circle */}
				<circle {...circleProps} r={radius} fill={backgroundColor}/>
				{/* Outer circle with ring */}
				<circle {...circleProps} r={center} fill={frameBody} mask="url(#ringMask)"/>
			</g>
			{/* Group containing the text */}
			<g>
				{textRender(text_1, frameBody, '50%', '#topTextPath')}
				{textRender(text_2, frameBody, '50%', '#bottomTextPath')}
			</g>
			<g
				transform={`translate(${centerX}, ${centerY}) scale(${scaleFactor}) translate(${-viewBoxSize / 2}, ${-viewBoxSize / 2})`}>
				{children}
			</g>
		</Svg>}
	</>);
}